import React from 'react';

import {
  GoogleLogin,
  GoogleLoginProps,
  GoogleLoginResponse,
} from 'react-google-login';
import styled from 'styled-components';

import {
  Box,
  BoxProps,
} from '@waglabs/box-next';

import { useGoogleLogin } from '../../hooks/api/useGoogleLogin';

import { 
  ENV_GOOGLE_CLIENT_ID,
} from '../../constants';

import LoadingBoneModal from '../../containers/WagSignUp/components/LoadingBoneOverlay';
import { GoogleLoginButtonIcon } from '../../icons';

/*
  Due to this issue with the react-google-login button
  important styles must be added to the button to override the
  underlying component. An alternate option would be to for the repo
  and apply the changes outlined in the issue.
  https://github.com/anthonyjgrove/react-google-login/issues/484
*/
const StyledGoogleLogin = styled(GoogleLogin)<{ error: boolean }>`
  box-shadow: unset !important;
  height:40px;
  background-color:#EDEDED !important;
  padding:0px !important;
  outline:none !important;
`;

export type GoogleLoginButtonProps = BoxProps & Partial<Omit<GoogleLoginProps, 'onSuccess'>> & {
  onSuccess?: (response: GoogleLoginResponse) => void;
  children?: string;
};

// TODO refactor to ContinueWithGoogleLoginButton
export const GoogleLoginButton = ({
  children = 'Continue with Google',
  onSuccess,
  ...rest
}: GoogleLoginButtonProps) => {
  const {
    isLoading: isGoogleLoginLoading,
  } = useGoogleLogin();

  return (
    <>
      {isGoogleLoginLoading && (
        <LoadingBoneModal />
      )}
      <Box
        as={StyledGoogleLogin}
        disabled={isGoogleLoginLoading}
        onSuccess={onSuccess}
        clientId={ENV_GOOGLE_CLIENT_ID}
        buttonText={children}
        icon={false}
        justifyContent="center"
        {...rest}
      >
        <GoogleLoginButtonIcon />
      </Box>
    </>
  );
};
